var _defs, _use, _use2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 6.4 56.4 56.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cu",
    gradientUnits: "userSpaceOnUse",
    x1: 8,
    y1: 6,
    x2: 56,
    y2: 60
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f2b81c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c98a06"
  })), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9,
    cy: 47.5,
    rx: 11,
    ry: 8,
    transform: "rotate(-24 13.9 47.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 45.5 L19 10 L57 18 L57 49 L51.5 49 L51.5 27 L24.5 21.5 L24.5 45.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.4,
    cy: 51,
    rx: 11,
    ry: 8,
    transform: "rotate(-24 46.4 51)"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#n",
    fill: "#a87200",
    stroke: "#a87200",
    strokeWidth: 2.6,
    strokeLinejoin: "round"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#n",
    fill: "url(#cu)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 44.5 Q9.9 40.5 15.4 41",
    stroke: "#fff6c8",
    strokeWidth: 1.7,
    fill: "none",
    opacity: 0.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4 48 Q42.4 44 47.9 44.5",
    stroke: "#fff6c8",
    strokeWidth: 1.7,
    fill: "none",
    opacity: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture);
export default __webpack_public_path__ + "static/media/culture.e09a5c3779504bf9fa659c5519fd0ec2.svg";
export { ForwardRef as ReactComponent };